module.exports = __webpack_public_path__ + "img/heart_structureFunction_summary.a36e9086.png";